module.exports = __webpack_public_path__ + "media/images/logo-dark-gray-c11b268f0118261bd11e70f633847613.svg";